<template>
  <v-container>
    <template v-if="!viewDataIsLoaded">
      <v-skeleton-loader
        type="card-heading, list-item-three-line"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <!--app-view-toolbar-->
      <app-view-toolbar :title="driverName"></app-view-toolbar>
      <v-alert v-if="isGreen" type="info">
        <div class="title">Välkommen till Chaffis!</div>
        För att kunna matchas mot jobb, behöver du lägga upp din yrkesprofil
        <br>
        <v-btn
          class="mt-4"
          @click="editMatchingData()"
        >
          Sätt igång
        </v-btn>
      </v-alert>
      <v-alert v-else-if="isUnmatched" type="info">
        <div class="title">Du matchas just nu</div>
        <v-progress-circular
          indeterminate
          color="white"
          size="40"
          width="4"
          class="my-2"
        ></v-progress-circular>
        <div class="text-body">Kan ta upp till 1 minut</div>
      </v-alert>
      <template
        v-else
      >
        <div class="text-h6 border-bottom">Jobb</div>
        <v-tabs
          color="accent"
          center-active
          show-arrows
        >
          <v-tab
            v-for="assignmentListData of viewData.assignmentListData_ar"
            :key="assignmentListData.label"
            :to="'#' + assignmentListData.label"
          >
            <v-badge
              :content="assignmentListData.listData.item_ar.length.toString()"
              color="accent"
              :value="assignmentListData.useBadge"
              :inline="true"
            >
              {{ assignmentListData.title }}
            </v-badge>
          </v-tab>
          <v-tab-item
            v-for="(assignmentListData, index) of viewData.assignmentListData_ar"
            :key="assignmentListData.label"
            :value="assignmentListData.label"
          >
            <v-container fluid class="pa-0">
              <v-text-field
                v-model="search[index]"
                prepend-icon="mdi-magnify"
                label="Sök"
                single-line
                hide-details
                clearable
                color="secondary"
              ></v-text-field>
              <v-data-table
                :headers="assignmentListData.listData.header_ar"
                :items="assignmentListData.listData.item_ar"
                :items-per-page="assignmentListData.itemsPerPage"
                :item-class="getRowClass"
                :hide-default-header="assignmentListData.listData.item_ar.length == 0"
                :hide-default-footer="assignmentListData.listData.item_ar.length == 0"
                @click:row="showAssignment"
                class="xClickRowTable"
                :search="search[index]"
              >
                <!--
                <template v-slot:top>
                  <v-toolbar
                    dense
                    flat
                    color="white"
                  >
                    <v-toolbar-title class="text-h6">
                      {{ assignmentListData.title }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="secondary"
                      small
                      dark
                      class="mb-2"
                      @click="addNewAssignment()"
                    >
                      <v-icon left>mdi-plus</v-icon>
                      Nytt jobb
                    </v-btn>
                  </v-toolbar>
                </template>
                -->
                <template v-slot:[`item.statusLabel`]="{ item }">
                  <v-tooltip
                    left
                    dark
                    :color="item.statusLabel == 'youHaveSigned' ? 'accent' : 'error'"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        v-if="item.statusLabel == 'youHaveSigned'"
                        color="accent"
                      >
                        mdi-check
                      </v-icon>
                      <v-icon
                        v-on="on"
                        v-else-if="item.statusLabel == 'otherHasBeenAssigned'"
                        color="error"
                      >
                        mdi-cancel
                      </v-icon>
                    </template>
                    <span v-show="item.statusLabel != ''"
                    >{{ item.statusText }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.hasSigned`]="{ item }">
                  <v-tooltip
                    left
                    dark
                    color="accent"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        v-if="item.hasSigned"
                        color="accent"
                      >
                        mdi-check
                      </v-icon>
                    </template>
                    <span v-show="item.hasSigned">Du signerade {{ item.signedDate }}</span>
                  </v-tooltip>
                </template>                <!--
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editAssignment(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                -->
                <template v-slot:no-data>
                  <div class="text-left">
                    {{ txtNoTableData }}
                  </div>
                </template>
              </v-data-table>
              <div class="text-caption pa-4">{{ assignmentListData.description }}</div>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </template>
    </template>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import ViewToolbar from '../components/ViewToolbar'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { mapGetters } from 'vuex'
import { snackBarBus } from '../main'

export default {
  components: {
    'app-snack-bar': SnackBar,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin],
  data() {
    return {
      refreshTimeout: null,
      viewDataIsLoaded: false,
      viewData: {},
      search: []
    }
  },
  computed: {
    ...mapGetters(['loggedInData', 'isGreen', 'agentId', 'access_token', 'version']),
    driverName() {
      return this.loggedInData.userData.name
    },
    txtNoTableData() {
      return this.viewDataIsLoaded ? 'Inga jobb finns' : 'Hämtar data...'
    },
    isUnmatched() {
      return this.viewDataIsLoaded ? this.viewData.isUnmatched : null
    }
  },
  methods: {
    getRowClass(item) {
      return item.cmpDeveloper ? 'developer-text' : ''
    },
    editMatchingData() {
      this.$router.push({ name: 'matching-edit', params: { id: this.agentId } })
    },
    showAssignment(value) {
      this.$router.push({ name: 'assignment', params: { uuid: value.uuid } })
    },
    doOnViewData(returnData) {
      this.viewData = returnData
      console.log('doOnViewData', returnData)
      if (this.viewData.isUnmatched) {
        //reload data due to pending matching
        this.refreshTimeout = setTimeout(this.loadViewData, 5000)
      }
      this.viewDataIsLoaded = true
      this.checkVersion()
    },
    loadViewData() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/driver/dashboard/' + this.loggedInData.agentData.id)
//      console.log('dashboard get', url)
      axios.get(url, config)
        .then(response => {
//          console.log('dashboard response', response)
          if (response.data.success) {
            //success
            this.doOnViewData(response.data.returnData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    checkVersion() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let postData = {
        version: this.version
      }
      let url = this.url_composeApiUrl('/common/check-version')
//      console.log('check-version', url)
      axios.post(url, postData, config)
        .then(response => {
//          console.log('check-version', response)
          if (response.data.success) {
            //success
            this.doOnCheckVersion(response.data.returnData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    doOnCheckVersion(data) {
      if (data.isOldVersion) {
        //reload due to old version
        window.location.reload()
      }
    }
  },
  created() {
    //get viewData
    this.loadViewData()
  },
  destroyed() {
    this.trace('DriverDashboard destroyed')
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout)
      this.trace('refreshTimeout cleared')
    }
  }
}
</script>

<style>

</style>